module.exports = __webpack_public_path__ + "assets/b45.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b45.png
// module id = 633
// module chunks = 0